import moment from 'moment-timezone';
import { useMemo } from 'react';
import { isItemForDate } from '../../filters/datetimeFilters';
import { eventMomentFactory } from '../../misc/eventMomentFactory';
/**
 * Memoized filter for programs/meetings/slots
 * @param {object} event Event object
 * @param {array} items Array of programs, meetings, or slots
 * @param {moment|string|number} date Date to filter on, or moment object
 * @param {string} [format] Date format if date is a string
 * @returns {array} Filtered array of items
 */

export function useItemsFilteredByDate(event, items = [], date, format) {
    return useMemo(() => {
        if (!date) return [];

        const parsedDate = moment.isMoment(date) ? date : eventMomentFactory(event, date, format);

        return items.filter((item) => isItemForDate(event, parsedDate, item));
    }, [event, date, items, format]);
}
